import { putField } from "../../../utils/form";
import { Divider } from "ant-design-vue";
import {
    createFieldRegister1,
    createFieldRegisterUserInfo,
    createFieldUsernamePassword
} from "../register/register.section";
import { defineAsyncComponent } from "vue";
import { conditionFormChecker } from "../../../utils/form";

const Address = defineAsyncComponent(() => import("../../../components/address/Address"));

export const createColumns = () => {
    const columns = [];
    return columns;
};

export const createField = ({ props, data, key, isLoading }) => {
    const { viewOnly, menuContext } = props;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            ...createFieldRegister1({ props, data, key, isLoading }),
            ...createFieldRegisterUserInfo({ props, data, key, isLoading }),
            ...createFieldUsernamePassword({ props, data, key, isLoading }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <Divider></Divider>
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => (
                    <Address
                        menuContext={menuContext}
                        viewOnly={viewOnly}
                        dataProp={data}
                        dataKey={`${prefix}addresses.0`}
                        isLoading={isLoading.value}
                    ></Address>
                )
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <Divider></Divider>
            },
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}sameAddressType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => (
                    <Address
                        menuContext={menuContext}
                        viewOnly={viewOnly}
                        dataProp={data}
                        dataKey={`${prefix}addresses.1`}
                        isLoading={isLoading.value}
                    ></Address>
                )
            },
        ]
    });
};
